import './style.css';

export const TransparentButton = ({ children, className = '', onClick }) => {
  return (
    <button type="button" className={`${className} button-transparent`} onClick={onClick}>
      {children}
    </button>
  );
};
